import React from 'react';
import Search from "./Search";
import Stories from "./Stories";
import Pagination from "./Pagination";
import "./App.css";


function App() {

  return (
    <>
    <Search />
    <Pagination />
    <Stories />
    </>
  );
}

export default App;